module.exports = __webpack_public_path__ + "img/droplet-fill.49bf14a1.svg";